import { useState, useEffect } from 'react';
import { Box, MenuItem, FormHelperText } from '@mui/material';
import {
  DialogContainer,
  DialogTitle,
  DialogBody,
  DialogActions,
  CustomTextField,
  CustomSelect,
} from '../../../common/components';

const PaymentMethodDialog = ({ open, onClose, onSave, selectedItem, editMode }) => {
  const [formData, setFormData] = useState({
    name: '',
    low_date: '',
    outlined_in_contract: '',
  });

  const [errors, setErrors] = useState({});
  const [saveAttempted, setSaveAttempted] = useState(false);

  useEffect(() => {
    if (open) {
      setFormData({
        name: selectedItem?.name || '',
        low_date: selectedItem?.low_date
          ? new Date(selectedItem.low_date).toISOString().split('T')[0]
          : '',
        outlined_in_contract:
          selectedItem?.outlined_in_contract !== undefined
            ? selectedItem.outlined_in_contract.toString()
            : '',
      });
      setErrors({});
      setSaveAttempted(false);
    }
  }, [open, selectedItem]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: false,
      }));
    }
  };

  const handleSelectChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name) {
      newErrors.name = true;
    }
    if (!formData.low_date) {
      newErrors.low_date = true;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = () => {
    setSaveAttempted(true);

    if (validateForm()) {
      onSave(formData);
    }
  };

  return (
    <DialogContainer open={open} onClose={onClose} size="small">
      <DialogTitle>
        {editMode ? `Editar Forma de Pago "${formData.name}"` : 'Nueva Forma de Pago'}
      </DialogTitle>

      <DialogBody sx={{ display: 'block' }}>
        <Box>
          <Box sx={{ display: 'block' }}>
            <CustomTextField
              margin="dense"
              name="name"
              label="Nombre"
              type="text"
              fullWidth
              value={formData.name}
              onChange={handleInputChange}
              error={errors.name || (saveAttempted && !formData.name)}
            />
            {(errors.name || (saveAttempted && !formData.name)) && (
              <FormHelperText error>Debes ingresar un nombre.</FormHelperText>
            )}

            <CustomTextField
              margin="dense"
              name="low_date"
              label="Fecha Baja"
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
              fullWidth
              value={formData.low_date}
              onChange={handleInputChange}
              error={errors.low_date || (saveAttempted && !formData.low_date)}
            />
            {(errors.low_date || (saveAttempted && !formData.low_date)) && (
              <FormHelperText error>Debes ingresar una fecha.</FormHelperText>
            )}

            <CustomSelect
              label={'Destacar en contrato'}
              labelId="outlined_in_contract-label"
              name="outlined_in_contract"
              value={formData.outlined_in_contract}
              onChange={handleSelectChange}
            >
              <MenuItem value="1">Si</MenuItem>
              <MenuItem value="0">No</MenuItem>
            </CustomSelect>
          </Box>
        </Box>
      </DialogBody>

      <DialogActions handleClose={onClose} handleSave={handleSave} />
    </DialogContainer>
  );
};

export default PaymentMethodDialog;
